import {
  GlobalStore,
  GridStore,
  ProcessEntitlements,
} from '@roc/feature-app-core';
import { CLOSING, DRAWS, PAYOFF, SERVICING, TRADES, UNDERWRITING } from '@roc/feature-utils';
import { action, computed, makeObservable, observable } from 'mobx';
import { LoanTodoStore } from './loanTodoStore';
import { Document } from '@roc/feature-types';

export abstract class LoanBaseStore {
  protected globalStore: GlobalStore;

  abstract myFundedLoansForDrawsGridStore: GridStore;
  abstract fundedLoansForPayoffGridStore: GridStore;
  abstract fundedLoansForExtensionsGridStore: GridStore;
  abstract loanDetails;

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;

    makeObservable(this, {
      getLoanProcessEntitlements: action,
      getLoanProcessEntitlementsUsingDocument: action,
      loanDetails: observable,
    });
  }

  getLoanProcessEntitlements(loanProcess: string, document: Document): ProcessEntitlements {
    const { userFeatures } = this.globalStore;
    if (!userFeatures) return null;
    if (document !== null && loanProcess === 'to-dos') {
      return this.getLoanProcessEntitlementsUsingDocument(document);
    }
    if (loanProcess === UNDERWRITING) {
      return userFeatures.underwritingEntitlements;
    } else if (loanProcess === CLOSING) {
      return userFeatures.closingEntitlements;
    } else if (loanProcess === DRAWS) {
      return userFeatures.drawsEntitlements;
    } else if (loanProcess === SERVICING) {
      return userFeatures.servicingEntitlements;
    } else if (loanProcess === PAYOFF) {
      return userFeatures.payoffEntitlements;
    }
  }

  getLoanProcessEntitlementsUsingDocument(document: Document) {
    const { userFeatures } = this.globalStore;
    const loanProcess = document.loanProcess.toLowerCase();
    if (!userFeatures) return null;
    if (loanProcess === UNDERWRITING) {
      return userFeatures.underwritingEntitlements;
    } else if (loanProcess === CLOSING) {
      return userFeatures.closingEntitlements;
    } else if (loanProcess === DRAWS) {
      return userFeatures.drawsEntitlements;
    } else if (loanProcess === SERVICING) {
      return userFeatures.servicingEntitlements;
    } else if (loanProcess === TRADES) {
      return userFeatures.tradeEntitlements;
    } else if (loanProcess === PAYOFF) {
      return userFeatures.payoffEntitlements;
    }
  }

}
